import styles from "./Login.module.css";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { InputAdornment, FormControlLabel, Checkbox } from "@mui/material";
import Icon from "@mdi/react";
import { mdiEye, mdiEyeOff } from "@mdi/js";

// React
import React, { useState, useContext } from "react";
import { Redirect } from "react-router-dom";

// context
import { MyContext } from "components/RoleContext";
import { Role } from "tools/Enums";

// Tools
import Services from "tools/Services";
import Loader from "components/Loader";

const LOGO_URL = "https://cloudfront.private-radar.com/img/logo/logo_login.png";

export default function Login() {
	const [{ email, password }, setFormValues] = useState({ email: "", password: "" });
	const [redirect, setRedirect] = useState(false);
	const [error, setError] = useState(false);
	const [showPassword, setShowPassword] = useState(false);
	const [rememberPassword, setRememberPassword] = useState(false);
	const [loading, setLoading] = useState(false);
	const { role, setRole } = useContext(MyContext);

	// Handles
	const handleClickLogin = async (e) => {
		setLoading(true);
		e.preventDefault();

		const credentials = {
			userName: email,
			password: password,
		};

		// POST
		let res = await Services.post("/Login/GetToken", credentials);
		setLoading(false);

		// ERROR
		if (res.status !== 200) {
			Services.clearToken();
			setError(true);
			setLoading(false);
			console.error(res);
			return;
		}

		// SUCCESS
		res.data.role === "Admin" ? setRole(Role.Admin) : setRole(Role.User);
		Services.setToken(res.data.refreshToken, rememberPassword);
		setRedirect(true);
	};

	const handleChangeRememberPassword = (e) => {
		setRememberPassword(e.target.checked);
	};
	const handleClickShowPassword = () => {
		setShowPassword(!showPassword);
	};
	const handleChangeForm = (e) => {
		setFormValues({ email, password, [e.target.name]: e.target.value });
		setError(false);
	};

	return (
		<>
			{redirect || (role !== Role.Unauthorized && <Redirect to="/dashboard" />)}
			<div className={styles.container}>
				<img src={LOGO_URL} alt="logo" />
				<div className={styles.title}>ROADMAP</div>
				<form onSubmit={handleClickLogin} className={styles.form}>
					<TextField
						variant="standard"
						error={error}
						name="email"
						label={"Email"}
						type="text"
						value={email}
						onChange={handleChangeForm}
					/>
					<TextField
						variant="standard"
						error={error}
						name="password"
						label="Password"
						type={showPassword ? "text" : "password"}
						value={password}
						onChange={handleChangeForm}
						InputProps={{
							endAdornment: (
								<InputAdornment
									position="end"
									onClick={handleClickShowPassword}
									className={styles.adornment}
								>
									{showPassword ? (
										<Icon path={mdiEye} size={0.9} />
									) : (
										<Icon path={mdiEyeOff} size={0.9} />
									)}
								</InputAdornment>
							),
						}}
					/>
					<FormControlLabel
						control={
							<Checkbox
								value="remember"
								color="primary"
								sx={{ "& .MuiSvgIcon-root": { fontSize: 16 } }}
								checked={rememberPassword}
								onChange={handleChangeRememberPassword}
							/>
						}
						label="Remember me"
					/>
					{loading ? (
						<Loader />
					) : (
						<Button type="submit" variant="outlined" className={styles.loginButton}>
							Login
						</Button>
					)}
					{error && (
						<div className={styles.error}>
							Sorry, your email or password was incorrect. Please double-check your email or password.
						</div>
					)}
					{/* <a href="todo" className={styles.link}>
						Forgot your password?
					</a> */}
				</form>
			</div>
		</>
	);
}
